import { makeStyles } from "@material-ui/core/styles";

export const useCampaignBriefProductsTabStyles = makeStyles(() => ({
  marginRight: {
    marginRight: "15px",
  },
}));
